
import ApiServiceAxios from '../service/ApiServiceAxios';
import MethodService from '../service/MethodService';
import { Buffer } from 'buffer';

let moduleApi = {};
let token = MethodService.getToken();
let UrlApiEhr = window.MyConfig.ehrUrl;

moduleApi.GetEhrDoctor = async (account) => {

    const body = {
        "ApiData": { LOGINNAME__EXACT: account }
    };
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiEhr + "EhrDoctor/Get?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
};

moduleApi.GetListEhrDoctor = async (search,
    page,
    Start,
    Limit,
    SPECIALIST_NAME,
    PROVINCE_ID,
    LICENSE_CODE__EXACT,
    tokenAPI) => {
    const body = {
        "ApiData": {
            "KEY_WORD": search ? search : '',
            "SPECIALIST_NAMES": SPECIALIST_NAME ? SPECIALIST_NAME : '',
            "DEGREE_NAMEs": '',
            "ORDER_DIRECTION": 'ASC',
            "ORDER_FIELD": 'FIRST_NAME',
            "IS_ACTIVE": '1',
            "PROVINCE_ID": PROVINCE_ID ? PROVINCE_ID : '',
            "LICENSE_CODE__EXACT": LICENSE_CODE__EXACT ? LICENSE_CODE__EXACT : ''
        },
        "CommonParam": { "page": page, "Start": Start, "Limit": Limit }
    };
    const objJsonB64 = Buffer.from(JSON.stringify(body)).toString('base64');
    let api = {
        method: "GET",
        url: UrlApiEhr + "EhrDoctor/Get?param=" + objJsonB64,
        headers: {
            ApplicationCode: window.MyConfig.applicationCode831,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            TokenCode: tokenAPI ? tokenAPI : token,
        },
        message: {
            success: "",
            error: "",
        },
    };
    return ApiServiceAxios(api);
};


export default moduleApi;
